export type NetworkCenterRingsProps = {
  x: number;
  y: number;
};

// These rings render behind the center node core. The GA mark is intentionally
// separate because SVG paint order must place it above that core.
export function NetworkCenterRings({ x, y }: NetworkCenterRingsProps) {
  return (
    <>
      <circle
        cx={x}
        cy={y}
        r="12"
        stroke="var(--ga-line)"
        strokeWidth="0.4"
        strokeDasharray="1.5 2.5"
        opacity="0.25"
        className="animate-[ga-radar-cw_50s_linear_infinite]"
        style={{ transformOrigin: `${x}px ${y}px` }}
      />
      <circle
        cx={x}
        cy={y}
        r="15"
        fill="none"
        stroke="var(--ga-signal)"
        strokeWidth="0.3"
        className="animate-[ga-center-ripple_3.2s_ease-in-out_infinite]"
        style={{ transformOrigin: `${x}px ${y}px` }}
      />
    </>
  );
}
